"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SignalR = require("@microsoft/signalr");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../../Services");
var ConnectionStatePanel = /** @class */ (function (_super) {
    __extends(ConnectionStatePanel, _super);
    function ConnectionStatePanel(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function (statePropName, newValue) {
            var _a;
            _this.setState((_a = {}, _a[statePropName] = newValue, _a));
        };
        _this.connectionState = function () {
            if (_this.state.isReconnecting || _this.props.applicationData.connectionState == SignalR.HubConnectionState.Reconnecting) {
                if (_this.state.veriliteConnectionStateHover) {
                    _this.setState({ veriliteConnectionStateHover: false });
                }
                return React.createElement(reactstrap_1.Badge, { color: "warning", pill: true }, _this.props.applicationData.resources.Reconnecting);
            }
            if (_this.props.applicationData.connectionState == SignalR.HubConnectionState.Disconnected) {
                return React.createElement(reactstrap_1.Badge, { color: "dark", style: { cursor: "pointer" }, onClick: function () {
                        setTimeout(function () {
                            Services_1.SignalRConnection.startConnection();
                            _this.setState({ isReconnecting: false });
                        }, 2000);
                        _this.setState({ isReconnecting: true });
                    }, onMouseEnter: function () { return _this.toggle("veriliteConnectionStateHover", true); }, onMouseLeave: function () { return _this.toggle("veriliteConnectionStateHover", false); }, pill: true }, _this.state.veriliteConnectionStateHover ? _this.props.applicationData.resources.Reconnect + "?" : _this.props.applicationData.resources[_this.props.applicationData.connectionState]);
            }
            else if (_this.state.veriliteConnectionStateHover) {
                _this.setState({ veriliteConnectionStateHover: false });
            }
            if (_this.props.applicationData.connectionState == SignalR.HubConnectionState.Connected) {
                return React.createElement(reactstrap_1.Badge, { color: "success", pill: true }, _this.props.applicationData.resources[_this.props.applicationData.connectionState]);
            }
            return React.createElement(reactstrap_1.Badge, { color: "secondary", pill: true }, _this.props.applicationData.resources[_this.props.applicationData.connectionState]);
        };
        _this.nbsConnectionState = function () {
            if (_this.props.applicationData.connectionState != SignalR.HubConnectionState.Connected) {
                return React.createElement(reactstrap_1.Badge, { color: "secondary", pill: true }, _this.props.applicationData.resources.Unknown);
            }
            if (_this.props.applicationData.nbsIsConnected) {
                return React.createElement(reactstrap_1.Badge, { color: "success", pill: true }, _this.props.applicationData.resources.Connected);
            }
            else {
                return React.createElement(reactstrap_1.Badge, { color: "warning", pill: true }, _this.props.applicationData.resources.Connecting);
            }
        };
        _this.state = {
            veriliteConnectionStateHover: false,
            isReconnecting: false
        };
        return _this;
    }
    ConnectionStatePanel.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, null, this.props.applicationData.resources.VeriLiteStatus),
                React.createElement(reactstrap_1.Col, { md: "auto" }, this.connectionState())),
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, null, this.props.applicationData.resources.NBSConnectivity),
                React.createElement(reactstrap_1.Col, { md: "auto" }, this.nbsConnectionState()))));
    };
    return ConnectionStatePanel;
}(React.Component));
exports.ConnectionStatePanel = ConnectionStatePanel;
//# sourceMappingURL=ConnectionStatePanel.js.map